import httpClient from '../httpClient';

const info = async (id) => {
  return await httpClient.get(`/mass_modification_products/${id}/info/`);
};

const post = async (data) => {
  return await httpClient.post('/mass_modification_products/', data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/mass_modification_products/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/mass_modification_products/${id}/`);
};

const renumerate = async (modificacion_id) => {
  return await httpClient.post('/mass_modification_products/renumerate/', {
    mm: modificacion_id,
  });
};
const swap = async (a, b) => {
  return await httpClient.post('/mass_modification_products/swap/', {
    a: a,
    b: b,
  });
};

const move = async (id, data) => {
  return await httpClient.patch(
    `/mass_modification_products/${id}/move/`,
    data,
  );
};

const duplicate = async (id, values) => {
  return await httpClient.patch(
    `mass_modification_products/${id}/duplicate/`,
    values,
  );
};

const view_home = async (query, page = 1, pageSize = 10, search = false) => {
  return await httpClient.get(
    `/mass_modification_products/view_home/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
      search ? `&filter[search]=${search}` : ''
    }`,
  );
};

const filter = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_products/export/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_products/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const get = async (id) =>
  await httpClient.get(`/mass_modification_products/${id}/`);

const preview = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_products/export_preview/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_products/preview/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const patchModule = async (id, data) => {
  return await httpClient.patch(
    `/mass_modification_products/${id}/update_module/`,
    data,
  );
};

export {
  info,
  post,
  patch,
  remove,
  filter,
  get,
  swap,
  preview,
  view_home,
  patchModule,
  renumerate,
  move,
  duplicate,
};
